import type { AccommodationDto } from '@hcr/api/consumer'
import { isNotNull } from '@hcr/utils'

import type { TicketsCount } from '../../hooks'

export const createAccommodationTicketsTotalCount = (
  ticketsCount: TicketsCount | null,
  accommodation: AccommodationDto
): number => {
  if (
    !isNotNull(ticketsCount) ||
    !ticketsCount[accommodation.resort_id] ||
    typeof ticketsCount[accommodation.resort_id][accommodation.accommodation_id] !== 'number'
  ) {
    return 0
  }

  return (
    ticketsCount[accommodation.resort_id][accommodation.accommodation_id] +
    ticketsCount[accommodation.resort_id].singleTickets
  )
}
